var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.105 1.895H.947V0h15.158v1.895m-6.631 9c0 1.08.407 2.236.947 3.316v.947H.947V9.474H0V7.579l.947-4.737h15.158l.663 3.316a4.933 4.933 0 0 0-2.084-.474c-2.842 0-5.21 2.369-5.21 5.21m-.948-1.42H2.842v3.79h5.684v-3.79M18 10.894c0 2.464-3.316 6.159-3.316 6.159s-3.316-3.695-3.316-6.158c0-1.8 1.516-3.316 3.316-3.316 1.8 0 3.316 1.516 3.316 3.316m-2.179.094c0-.568-.568-1.136-1.137-1.136-.568 0-1.137.473-1.137 1.136 0 .569.474 1.137 1.137 1.137s1.232-.568 1.137-1.137z",
    id: "1ss3rzad2a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hm8wanay5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1ss3rzad2a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#1ss3rzad2a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hm8wanay5b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.588-2.118h21.176v21.176H-1.588z",
    fill: "#7B7794",
    id: "icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlace);
export default __webpack_public_path__ + "static/media/icon-place.6451d7ee830c3ebd118010bbb8455287.svg";
export { ForwardRef as ReactComponent };